import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-non-plm-recipe',
  templateUrl: './non-plm-recipe.component.html',
  styleUrls: ['./non-plm-recipe.component.scss']
})
export class NonPlmRecipeComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
